module.exports = __webpack_public_path__ + "img/brown-wooden-base-ceramic-washcloset-3258310.6cc92fa6.jpg";